import { Navigate, useParams, useLocation } from "react-router-dom";
import { ReactNode, useEffect } from "react";
import { useLanguage } from "@/hooks/useLanguage";
import { localizedRedirect } from "@/lib/localizedRedirect";

interface LanguageRouteProps {
  children: ReactNode;
  /** For routes without a `:lang` segment: the Czech pages at the root (`/kontakt`). */
  lang?: "cs" | "en";
}

/**
 * Wrapper component that validates language parameter and redirects if invalid
 */
export function LanguageRoute({ children, lang: fixedLang }: LanguageRouteProps) {
  const params = useParams<{ lang: string }>();
  const lang = fixedLang ?? params.lang;
  const location = useLocation();
  const { language, setLanguage } = useLanguage();

  // Sync language from URL to state (always run this hook)
  useEffect(() => {
    if (lang && ["cs", "en"].includes(lang) && lang !== language) {
      setLanguage(lang as "cs" | "en");
    }
  }, [lang, language, setLanguage]);

  // Validate language parameter
  if (lang && ["cs", "en"].includes(lang)) {
    return <>{children}</>;
  }

  return <Navigate to={localizedRedirect(location, language)} replace />;
}
